module.exports = __webpack_public_path__ + "static/media/CTAMarketingMaterials-gray.194b4293.png";